// @flow
// -----------------------------------------------------------------
// <copyright                                                       
//   file="Izenda.RequestBuilderHeaders.js"                         
//   company="Izenda">                                              
//  Copyright (c) 2015 Izenda, Inc.                                 
//  ALL RIGHTS RESERVED                                             
//                                                                  
//  The entire contents of this file is protected by U.S. and       
//  International Copyright Laws. Unauthorized reproduction,        
//  reverse-engineering, and distribution of all or any portion of  
//  the code contained in this file is strictly prohibited and may  
//  result in severe civil and criminal penalties and will be       
//  prosecuted to the maximum extent possible under the law.        
//                                                                  
//  RESTRICTIONS                                                    
//                                                                  
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES           
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE                          
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS              
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET    
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.                 
//                                                                  
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED      
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE        
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE       
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT  
//  AND PERMISSION FROM IZENDA INC.                                 
//                                                                  
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  
//  ADDITIONAL RESTRICTIONS.                                        
// </copyright>                                                     
// -----------------------------------------------------------------

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import connect from 'share/enhancers/Izenda.Connect';

import localizer from 'share/localization/Izenda.Localizer';
import { Table, Column } from 'share/components/controls/DataGrid/Izenda.Table';
import { TableDefitionHeaders as TABLE_DEF } from 'logic/data/Izenda.RequestBuilderConstants';
import InputByDataType from 'share/components/controls/Izenda.InputByDataType';
import { IzendaRequestHeader } from 'logic/models/Izenda.Request';
import Button from 'share/components/controls/Izenda.Button';
import Panel from 'share/components/controls/Izenda.Panel';
import Input from 'share/components/controls/Izenda.Input';

/**
 * Collapsible header component
 */
const RequestBuilderHeaderPanelHeader = connect()(props => {
  const { isExpanded, request, title, icon, className, collapseToggle, style } = props;

  const renderAddHeaderButton = () => {
    if (!isExpanded)
      return null;
    return (
      <div className="btn-group u_floatRight" role="group" style={style}>
        <Button
          className="btn-report-default dropdown-toggle"
          data-toggle="dropdown"
          label={localizer.getText("REQUEST_BUILDER_HEADERS_PRESETS")}>
          <span className="caret"/>
        </Button>
      </div>
    );
  };

  return (
    <div>
      <strong onClick={collapseToggle} style={style} className={className}>
        {icon ? <i className={icon}/> : null}
        {title} {!!request.headersCount && `(${request.headersCount})`}
      </strong>
      {/*{renderAddHeaderButton()}*/}
    </div>
  );
});

/**
 * Request builder headers editor component
 */
@connect()
export default class RequestBuilderHeader extends Component {
  static propTypes = {
    request: PropTypes.any.isRequired // IzendaRequest
  };

  renderHeaderEnabled = (header: IzendaRequestHeader): any => {
    const { props } = this;
    const request: IzendaRequest = props.request;
    if (request.headers.indexOf(header) === request.headers.length - 1 && !header.name)
      return null;

    const handleEnabledChange = (e) => {
      header.setEnabled(e.target.checked);
    };
    return (
      <Input type='checkbox' className="u_marginLeft" checked={header.enabled} onChange={handleEnabledChange}/>
    );
  };

  renderHeaderName = (header: IzendaRequestHeader): any => {
    const { props } = this;
    const request: IzendaRequest = props.request;

    const onChange = e => {
      const newValue = e.value;
      header.setName(newValue);
      request.addEmptyLastHeader();
    };
    return (
      <InputByDataType
        type="text"
        onChange={onChange}
        value={header.name}
      />
    );
  };

  renderHeaderValue = (header: IzendaRequestHeader): any => {
    const onChange = e => {
      const newValue = e.value;
      header.setValue(newValue);
    };

    return (
      <InputByDataType
        type="text"
        onChange={onChange}
        value={header.value}
      />
    );
  };

  renderHeaderDelete = (header: IzendaRequestHeader) => {
    const { props } = this;
    const request: IzendaRequest = props.request;
    if (request.headers.indexOf(header) === request.headers.length - 1 && !header.name)
      return null;
    const deleteField = () => {
      request.removeHeader(header);
    };
    return (
      <a onClick={deleteField}>
        <span className="icon-cancel"/>
      </a>
    );
  };

  render() {
    const { props } = this;
    const request: IzendaRequest = props.request;

    const panelHeaderProps = {
      title: localizer.getText('REQUEST_BUILDER_HEADERS_TITLE'),
      icon: 'icon-toggle-triangle',
      className: 'u_noPaddingLeft u-bgGray',
      request: request,
      component: RequestBuilderHeaderPanelHeader
    };
    return (
      <Panel
        collapsible
        expanedOption
        header={panelHeaderProps}
      >
        <Table dataSource={request.headers} maxHeight={200} minHeight={200} staticRender>
          <Column {...TABLE_DEF['enabled']} cell={this.renderHeaderEnabled}/>
          <Column {...TABLE_DEF['name']} cell={this.renderHeaderName}/>
          <Column {...TABLE_DEF['value']} cell={this.renderHeaderValue}/>
          <Column {...TABLE_DEF['delete']} cell={this.renderHeaderDelete}/>
        </Table>
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/ConnectionStringBuilderRest/Izenda.RequestBuilderHeaders.js